import type { APIResponse } from "@kamae-apps/shared/Types/ApiResponse"
import type User from "@kamae-apps/shared/Types/User"
import { apiRequest, apiRequestRaw } from "@kamae-apps/shared/utils"
import { BatchResult } from "../Components/BatchErrorModal/type"

class UserService {
  fetchUserData(): Promise<User> {
    try {
      return apiRequest<User>("/user?v2=true", { name: "v2" })
    } catch (error) {
      throw new Error(error)
    }
  }

  fetchUserV1Data(): Promise<User> {
    try {
      return apiRequest<User>("/user", { name: "v2" })
    } catch (error) {
      throw new Error(error)
    }
  }

  updateUserData(body: User): Promise<User> {
    try {
      return apiRequest("/user?v2=true", {
        name: "v2",
        method: "PUT",
        body,
      })
    } catch (error) {
      throw new Error(error)
    }
  }

  importUserBatch(csvContent: ArrayBuffer | string | null, languageId: number): Promise<BatchResult> {
    return apiRequestRaw(`/users/batch?languageId=${languageId}`, "text/csv; charset=utf-8", {
      method: "POST",
      body: csvContent,
    }) as Promise<BatchResult>
  }

  getAuthMethod(email: string): Promise<APIResponse<string>> {
    return apiRequest<APIResponse<string>>(`/user/auth?mail=${email.toLowerCase()}`)
  }
}

export const userService = new UserService()
